import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DeleteOutputData.css';
import { Input, Button, Drawer, Select } from 'antd';
// import SideClose from "../../../../Assets/ModalClose.svg";
import {
    SupportingDocumentOutputDeleteHandler,
    clearDocumentsSupportingData,
} from '../../../../Redux/Actions/user/SupportingOutputDocumentsDelete';
const { TextArea } = Input;

const DeleteOutputData = ({
    handleDeleteOutputData,
    isDeleteOutputData,
    editOutputData,
    handleDeleteOutputDataButton,
    setDeleteOutPutFormet,
}) => {
    let SideClose = '/assets/ModalClose.svg';
    let topDomainValue = null;
    let excludeValue = null;
    if (editOutputData.type === 'url') {
        const urlSettingsObj = JSON.parse(editOutputData.url_settings);
        topDomainValue = urlSettingsObj.top_domain;
        excludeValue = urlSettingsObj.exclude;
    }
    let dispatch = useDispatch();
    const supportingdocumentdeleteData = useSelector(
        (state) =>
            state?.SupportingOutputDocumentDeletedata
                ?.Supporting_output_document_output_delete_data
    );
    const onDeletehandle = (id) => {
        dispatch(SupportingDocumentOutputDeleteHandler(id));
        handleDeleteOutputDataButton();
        setDeleteOutPutFormet(true);
    };
    useEffect(() => {
        if (supportingdocumentdeleteData) {
            handleDeleteOutputData(false);
            // dispatch(clearDocumentsSupportingData());
        }
    }, [supportingdocumentdeleteData, dispatch]);
    return (
        <>
            <Drawer
                placement='right'
                closable={false}
                onClose={handleDeleteOutputDataButton}
                open={isDeleteOutputData}
                key='right'
                width={'40%'}>
                <img
                    className='delete-refer-data-sideClose'
                    src={SideClose}
                    alt=''
                    onClick={handleDeleteOutputDataButton}
                />
                <div className='delete-refer-data-modal-div'>
                    <h3>Output Format</h3>
                </div>
                <div className='delete-refer-data-1'>
                    <label>Output Format name</label>
                    <Input
                        placeholder='Basic usage'
                        value={editOutputData.name}
                    />
                </div>
                <div className='delete-refer-data-2'>
                    <label>
                        Context to frame reference data (edit if required)
                    </label>
                    <Input
                        placeholder='Basic usage'
                        value={editOutputData.context}
                    />
                </div>
                {/* File Delete */}
                {editOutputData.type === 'file' ? (
                    <div className='delete-refer-data-input'>
                        <div className='delete-refer-data-2'>
                            <label>Reference data</label>
                            <div className='delete-refer-data-img-height-320'>
                                <div className='delete-refer-data-main-div'>
                                    <div className='delete-refer-data-span'>
                                        <div className='delete-refer-data-middle-div-first-p'>
                                            {
                                                editOutputData.files[0][
                                                    'filename'
                                                ]
                                            }
                                        </div>
                                        <div className='delete-refer-data-middle-div-second-p'>
                                            Word Count:{' '}
                                            {
                                                editOutputData.files[0][
                                                    'word_count'
                                                ]
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='delete-refer-data-main-content'>
                                {editOutputData.files[0]['content']}
                            </div>
                        </div>
                    </div>
                ) : null}

                {/* Url Delete */}
                {editOutputData.type === 'url' ? (
                    <div className='delete-refer-data-input'>
                        <div className='delete-refer-data-2'>
                            <h3>Live reference data</h3>
                            <label>Set-up URL to monitor</label>
                            <div className='delete-refer-data-input'>
                                <div className='delete-refer-data-1'>
                                    <label>
                                        Scrape a website using the Top Level
                                        Domain
                                    </label>
                                    <Input
                                        placeholder='Enter your top_domain'
                                        value={topDomainValue}
                                    />
                                </div>
                                <div className='delete-refer-data-2'>
                                    <label>
                                        List any URLs you do not want to scrape
                                        on this website
                                    </label>
                                    <Input
                                        placeholder='Enter your exclude_urls'
                                        value={excludeValue}
                                    />
                                </div>
                            </div>
                            <div className='delete-refer-data-modal-div'>
                                <h3>Or</h3>
                            </div>
                            <div className='delete-refer-data-input'>
                                <div className='delete-refer-data-1'>
                                    <label>Scrape a single URL</label>
                                    <Input placeholder='Enter your single_url' />
                                </div>
                                <div className='delete-refer-data-2'>
                                    <label>Frequency</label>
                                    <Select
                                        defaultValue={editOutputData.frequency}
                                        options={[
                                            { value: 'off', label: 'off' },
                                            { value: 'once', label: 'once' },
                                            {
                                                value: 'quarterly',
                                                label: 'quarterly',
                                            },
                                            {
                                                value: 'monthly',
                                                label: 'monthly',
                                            },
                                            {
                                                value: 'weekly',
                                                label: 'weekly',
                                            },
                                            { value: 'daily', label: 'daily' },
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {/* Text Delete */}
                {editOutputData.type === 'text' ? (
                    <div className='delete-refer-data-input'>
                        <div className='delete-refer-data-2'>
                            <label>Reference data</label>
                            <TextArea rows={4} value={editOutputData.data} />
                        </div>
                    </div>
                ) : null}

                <div className='delete-refer-data-main-content'>
                    <h5 className='delete-refer-data-h5'>
                        Delete Output Format
                    </h5>
                    <p className='delete-refer-data-p'>
                        Deleting {editOutputData.name} will remove it from your
                        workspace, and can't be undone.
                    </p>
                    <div className='delete-refer-data-input'>
                        <div className='delete-refer-data-supporting-div'>
                            <Button
                                className='delete-refer-data-supporting-button'
                                onClick={() =>
                                    onDeletehandle(editOutputData.id)
                                }>
                                Delete Document
                            </Button>
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    );
};
export default DeleteOutputData;
